import React from "react";
import { Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CampaignDetailsModal = ({ open, onClose, campaignData }) => {
  console.log("🚀 ~ ModalOpportunitySecond ~ campaignData:", campaignData);

  const FileIcon = ({ fileName }) => {
    const getFileIcon = (fileName) => {
      const extension = fileName.split(".").pop().toLowerCase();

      if (["png", "jpg", "jpeg", "gif", "webp", "bmp"].includes(extension)) {
        return "🖼️";
      } else if (
        ["mp4", "avi", "mov", "wmv", "flv", "webm", "mkv"].includes(extension)
      ) {
        return "🎬";
      } else if (["pdf"].includes(extension)) {
        return "📄";
      } else if (["doc", "docx"].includes(extension)) {
        return "📝";
      } else if (["xls", "xlsx"].includes(extension)) {
        return "📊";
      } else {
        return "📎";
      }
    };

    return <span className="text-lg">{getFileIcon(fileName)}</span>;
  };

  const renderActionButton = (campaignData) => {
    const baseStyle =
      "inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (campaignData?.status) {
      case "open":
        return (
          <span className={`${baseStyle} ${"bg-green-100 text-green-700"}`}>
            Open
          </span>
        );
      case "active":
        return (
          <span className={`${baseStyle} ${"bg-green-100 text-green-700"}`}>
            Active
          </span>
        );
      case "delete":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>Delete</span>
        );
      case "deleted":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>
            Deleted
          </span>
        );
      case "archive":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>
            Archive
          </span>
        );
      case "archived":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>
            Archived
          </span>
        );
      case "close":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>Close</span>
        );
      case "closed":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-600`}>Closed</span>
        );
      case "draft":
        return (
          <span className={`${baseStyle} ${"bg-blue-100 text-blue-700"}`}>
            Draft
          </span>
        );
      default:
        return (
          <span className={`${baseStyle} ${"bg-gray-100 text-gray-600"}`}>
            {campaignData?.application_status}
          </span>
        );
    }
  };

  const getPlatformIcon = (platformCode) => {
    const id = platformCode?.toString();

    switch (id) {
      case "IG":
        return (
          <div className="flex gap-2">
            <img
              src="/images/instagram.svg"
              alt="Instagram"
              width="24"
              height="24"
            />
          </div>
        );
      case "TT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/tiktok-logo.svg"
              alt="TikTok"
              width="24"
              height="24"
            />
          </div>
        );
      case "FB":
        return (
          <div className="flex gap-2">
            <img
              src="/images/facebook.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      case "YT":
        return (
          <div className="flex gap-2">
            <img
              src="/images/youtube.svg"
              alt="Facebook"
              width="24"
              height="24"
            />
          </div>
        );
      default:
        return <span>{platformCode || "NA"}</span>;
    }
  };

  // if (loading) {
  //   return (
  //     <Modal open={open} onClose={onClose}>
  //       <div className="flex items-center justify-center p-4 min-h-screen">
  //         <div className="bg-white rounded-lg p-8">
  //           <p>Loading Campaigns details...</p>
  //         </div>
  //       </div>
  //     </Modal>
  //   );
  // }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="application-details-modal"
      aria-describedby="application-details-description"
      className="flex items-center justify-center p-4"
    >
      <div className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-xl shadow-2xl outline-none overflow-hidden">
        <div className="sticky top-0 z-10 flex justify-between items-center p-6 py-3 border-b border-gray-200 bg-gradient-to-r from-green-600 to-green-700 text-white">
          <div>
            <Typography
              variant="h5"
              component="h2"
              className="font-bold text-white"
            >
              {campaignData?.title || "Untitled Campaign"}
            </Typography>
            <span className="text-sm text-green-950 font-medium italic">
              by {campaignData?.brand_name}
            </span>
          </div>

          <IconButton
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors"
            aria-label="close"
          >
            <CloseIcon className="text-white" />
          </IconButton>
        </div>

        <div
          className="overflow-y-auto max-h-[calc(90vh-88px)]"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#e5e7eb transparent",
          }}
        >
          <div className="px-6 pb-6 pt-3">
            <div className="md:col-span-2 flex justify-end !mb-0">
              <p className="text-lg text-center">
                Status : {renderActionButton(campaignData)}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <>
                <div className="space-y-4">
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Delivery Date
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.delivery_date
                        ? new Date(
                            campaignData.delivery_date
                          ).toLocaleDateString()
                        : "Not specified"}
                    </p>
                  </div>
                </div>
                {campaignData?.apply_by_date && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Apply By Date
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.apply_by_date
                        ? new Date(
                            campaignData.apply_by_date
                          ).toLocaleDateString()
                        : "Not specified"}
                    </p>
                  </div>
                )}
                {campaignData?.category_name && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Category
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.category_name || "Not specified"}
                    </p>
                  </div>
                )}
                {campaignData?.reach_min && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Minimum Reach
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData.reach_min?.toLocaleString()}
                    </p>
                  </div>
                )}
                {campaignData?.platform && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Social Platform
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {getPlatformIcon(campaignData?.platform)}
                    </p>
                  </div>
                )}
                {campaignData?.location && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Location
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.location}
                    </p>
                  </div>
                )}
                {campaignData?.application_count > 0 && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Application Count
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.application_count}
                    </p>
                  </div>
                )}
                {campaignData?.engagement_min && (
                  <div>
                    <p className="text-sm font-semibold text-gray-600 mb-1 uppercase tracking-wide">
                      Minimum Engagement
                    </p>
                    <p className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      {campaignData?.engagement_min}
                    </p>
                  </div>
                )}
                {campaignData?.hashtag && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Hashtag
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {campaignData?.hashtag}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.brand_website && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Website
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {campaignData?.brand_website}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.ctr_url && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Landing Page URL
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {campaignData?.ctr_url}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.compensation && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600  mb-1 uppercase tracking-wide">
                      Compensation
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg ">
                      <p className="text-base text-gray-900 font-medium">
                        {campaignData.compensation}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.scope_of_work && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Scope of Work
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                        {campaignData?.scope_of_work}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.delivery_info && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Delivery Information
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                        {campaignData.delivery_info}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.additional_info && (
                  <div className="md:col-span-2 ">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Additional Information
                    </p>
                    <div className="text-base text-gray-900 bg-gray-50 p-3 rounded-lg">
                      <p className="text-base text-gray-900 whitespace-pre-wrap leading-relaxed">
                        {campaignData.additional_info}
                      </p>
                    </div>
                  </div>
                )}
                {campaignData?.files && campaignData?.files.length > 0 && (
                  <div className="md:col-span-2">
                    <p className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">
                      Attached Files
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {campaignData.files.map((file, index) => {
                        const fileExtension = file.file_name
                          .split(".")
                          .pop()
                          .toLowerCase();
                        const isImage = [
                          "png",
                          "jpg",
                          "jpeg",
                          "gif",
                          "webp",
                          "bmp",
                        ].includes(fileExtension);
                        const isVideo = [
                          "mp4",
                          "avi",
                          "mov",
                          "wmv",
                          "flv",
                          "webm",
                          "mkv",
                        ].includes(fileExtension);

                        return (
                          <div
                            key={index}
                            className="bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-200 hover:border-green-300 group"
                          >
                            {/* File Preview Section */}
                            <div className="mb-3 flex justify-center">
                              {isImage ? (
                                <div className="relative w-full h-32 rounded-lg overflow-hidden">
                                  <img
                                    src={file.file_url}
                                    alt={file.file_name}
                                    className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform duration-200"
                                    onClick={() =>
                                      window.open(file.file_url, "_blank")
                                    }
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200" />
                                </div>
                              ) : isVideo ? (
                                <div className="relative w-full h-32 rounded-lg overflow-hidden bg-gray-100">
                                  <video
                                    className="w-full h-full object-cover rounded-lg"
                                    controls
                                    controlsList="nodownload"
                                  >
                                    <source
                                      src={file.file_url}
                                      type={`video/${fileExtension}`}
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              ) : (
                                <div className="w-full h-32 flex items-center justify-center bg-green-50 rounded-lg border-2 border-dashed border-green-200">
                                  <FileIcon fileName={file.file_name} />
                                </div>
                              )}
                            </div>

                            {/* File Info Section */}
                            <div className="flex items-start gap-3">
                              <div className="flex-shrink-0 mt-1">
                                <FileIcon fileName={file.file_name} />
                              </div>
                              <div className="flex-1 min-w-0">
                                <a
                                  href={file.file_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="block text-sm font-medium text-gray-900 hover:text-green-700 transition-colors truncate mt-2"
                                  title={file.file_name}
                                >
                                  {file.file_name}
                                </a>
                              </div>
                            </div>

                            {/* Action Button */}
                            <div className="mt-3 pt-3 border-t border-gray-100">
                              <a
                                href={file.file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-green-600 bg-green-50 hover:bg-green-100 rounded-lg transition-colors duration-200 border border-green-200 hover:border-green-300"
                              >
                                View File
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {(campaignData?.created_date || campaignData?.updated_at) && (
                  <div className="md:col-span-2">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="flex justify-between items-center flex-wrap gap-2">
                        {campaignData?.created_date && (
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                              Created:
                            </span>
                            <span className="text-sm text-gray-700 font-medium">
                              {new Date(
                                campaignData?.created_date
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                timeZone: "UTC",
                              })}
                            </span>
                          </div>
                        )}
                        {campaignData?.updated_at && (
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                              Updated:
                            </span>
                            <span className="text-sm text-gray-700 font-medium">
                              {new Date(
                                campaignData.updated_at
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                timeZone: "UTC",
                              })}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CampaignDetailsModal;
